//* Import API configurations
import { api } from "../../services/apis/configs/axiosConfigs";

//* Import API URI constant
import { API_URI } from "../../constants/consts";

//* Import PaginationData type
import { type Pagination } from "../../services/stores/types";

//* Import types from types
import { Demands, DemandsDetails, DemandsResponse } from "../demand/types/types";

export const demandsAPI = {
  getAll: async function (
    search: string = "",
    page: number = 1,
    token: string,
    perPage: number = 10
  ): Promise<DemandsResponse> {
    const searchQuery = search ? `&search=${search}` : "";
    const url = `${API_URI}/admin/private/demands?page=${page}&perPage=${perPage}${searchQuery}`;

    return api
      .request({
        url,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { data } = response.data;

        const pagination: Pagination = data.pagination
          ? {
              currentPage: data.pagination.currentPage,
              totalPages: data.pagination.totalPages,
              itemsPerPage: data.pagination.itemsPerPage,
              totalItems: data.pagination.totalItems,
            }
          : {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: 0,
              totalItems: 0,
            };

        return {
          demands: data.demands || [],
          pagination,
        };
      })
      .catch((error) => {
        console.error("Error fetching demands:", error);
        throw new Error("Failed to fetch demands");
      });
  },

  // Fetch a Demands by ID
  getById: async function (id: string, token: string): Promise<DemandsDetails> {
    return api
      .request({
        url: `${API_URI}/admin/private/demands/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        console.error("Error fetching Demands:", error);
        throw new Error("Failed to fetch Demands");
      });
  },

  // Create a new Demands
  create: async function (
    data: { name: string; desc: string; date: Date | string; time: string },
    token: string
  ): Promise<Demands> {
    return api
      .request({
        url: `${API_URI}/admin/private/demands`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error("Error creating Demands:", error, data);
        throw new Error("Failed to create Demands");
      });
  },

  // Update an existing Demands
  update: async function (
    id: string,
    data: {

        name: string;
        desc: string;
        date: Date | string;
        time: string;
      
    },
    token: string
  ): Promise<Demands> {
    return api
      .request({
        url: `${API_URI}/admin/private/demands/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error("Error updating Demands:", error);
        throw new Error("Failed to update Demands");
      });
  },

  // Delete an Demands by ID
  delete: async function (id: string, token: string): Promise<void> {
    return api
      .request({
        url: `${API_URI}/admin/private/demands/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {})
      .catch((error) => {
        console.error("Error deleting Demands:", error);
        throw new Error("Failed to delete Demands");
      });
  },
};
